export default {
  data() {
    return {
      SUBSCRIPTION_STATUS_ACTIVE: 'active',
      SUBSCRIPTION_STATUS_CANCELED: 'canceled',
      SUBSCRIPTION_ACTION_CANCEL: 'cancel',
      TRANSACTION_PAYMENT_METHOD_CHANGE: 'subscription_payment_method_change',
      TRANSACTION_STATUS_COMPLETED: 'completed',
    };
  },
  methods: {
    hasPendingCancellation(subscription) {
      return subscription.data.status !== this.SUBSCRIPTION_STATUS_CANCELED && subscription.data.scheduled_change?.action === this.SUBSCRIPTION_ACTION_CANCEL;
    },
    canViewBusiness(item) {
      return item.place && !item.place.deleted_at && item.place.active;
    },
    getSubscriptionEndsAt(subscription) {
      return subscription.data.current_billing_period?.ends_at ?? null;
    },
    canDownloadInvoice(transaction) {
      return !this.isZeroValuePaymentMethodUpdate(transaction) && transaction.data.status === this.TRANSACTION_STATUS_COMPLETED;
    },
    canCancel(subscription) {
      return subscription.data
        && subscription.data.status === this.SUBSCRIPTION_STATUS_ACTIVE
        && !this.hasPendingCancellation(subscription);
    },
    canEditPaymentMethod(subscription) {
      return subscription.data.next_billed_at !== null;
    },
    isZeroValuePaymentMethodUpdate(transaction) {
      return transaction.data.origin === this.TRANSACTION_PAYMENT_METHOD_CHANGE
        && Number(transaction.data.details.totals.subtotal) === 0
        && Number(transaction.data.details.totals.total) === 0;
    },
    getTransactionDisplayName(transaction) {
      if (this.isZeroValuePaymentMethodUpdate(transaction)) {
        return this.$t('Payment method update');
      }
      if (transaction.data.items[0].price.name) {
        return transaction.data.items[0].price.name;
      }
      return '';
    },
    getPlanName(item) {
      // subscription
      if (item.paddle_subscription_id) {
        if (item.data && item.data.items && item.data.items[0] && item.data.items[0].product) {
          return item.data.items[0].product.name;
        }
        return this.$t('Subscription');
      }

      // transaction
      if (item.data && item.data.details && item.data.details.line_items && item.data.details.line_items[0] && item.data.details.line_items[0].product) {
        return item.data.details.line_items[0].product.name;
      }
      return this.$t('Transaction');
    },
    getSingleBusinessUrl(placeId) {
      const localePrefix = this.$i18n.locale === 'en' ? '' : `${this.$i18n.locale}/`;
      const businessSlug = this.$i18n.locale === 'sr' ? 'biznis' : 'business';

      return `${process.env.VUE_APP_APP_URL}/${localePrefix}${businessSlug}/${placeId}`;
    },
  },
};
